import React, { FC, useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import BreadCrumbGeneric from "../../components/breadcrumb/breadcrumb_generic";
import {
  getMunicipalities,
  MunicipalityItem,
  MunicipalityListMeta,
} from "../../apis/municipalities";
import { MunicipalityList } from "../municipality-list/municipality-list";
import "../list/list.css";

export const MunicipiosListPage: FC = () => {
  const history = useHistory();

  const [municipalities, setMunicipalities] = useState<MunicipalityItem[]>([]);
  const [meta, setMeta] = useState<MunicipalityListMeta | undefined>();
  const [inputValue, setInputValue] = useState<string>("");
  const [search, setSearch] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(true);

  const loadMunicipalities = useCallback(
    async (page: number, searchValue: string) => {
      try {
        setLoading(true);
        const response = await getMunicipalities({
          page,
          perPage: 15,
          search: searchValue || undefined,
        });

        const data = Array.isArray(response.data) ? response.data : [];

        setMunicipalities(data);
        setMeta(response.meta);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching municipalities list:", error);
        setMunicipalities([]);
        setMeta(undefined);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  useEffect(() => {
    loadMunicipalities(currentPage, search);
  }, [currentPage, search, loadMunicipalities]);

  const handleSearchChange = useCallback((value: string) => {
    setInputValue(value);
  }, []);

  const handleSearchEnter = useCallback(() => {
    setCurrentPage(1);
    setSearch(inputValue);
  }, [inputValue]);

  const handlePageChange = useCallback((page: number) => {
    setCurrentPage(page);
  }, []);

  const handleMunicipalityClick = useCallback(
    (item: MunicipalityItem) => {
      const totalServices = item.statistics?.total_services ?? 0;
      const totalCategories = item.statistics?.total_categories ?? 0;
      const hasServices = totalServices > 0 || totalCategories > 0;
      const municipalityLink = item.parameters?.municipality_link;
      const hasMunicipalityLink = Boolean(municipalityLink);

      if (!hasServices && hasMunicipalityLink) {
        globalThis.window.open(municipalityLink as string, "_blank");
        return;
      }

      if (!hasServices && !hasMunicipalityLink) {
        return;
      }

      history.push(
        `/?municipio=${item.ibge_code}&nome=${encodeURIComponent(
          item.municipality
        )}`,
        {
          bannerUrl: item.parameters?.banner_url ?? null,
        }
      );
    },
    [history]
  );

  return (
    <div className="xvia-list">
      <BreadCrumbGeneric
        variant="municipios"
        props={[
          {
            name: "Municípios",
          },
        ]}
      />

      <MunicipalityList
        municipalities={municipalities}
        meta={meta}
        searchValue={inputValue}
        onSearchChange={handleSearchChange}
        onSearchEnter={handleSearchEnter}
        onPageChange={handlePageChange}
        onMunicipalityClick={handleMunicipalityClick}
        loading={loading}
      />
    </div>
  );
};
